class ConsumerPromotionActions {
  static CONSUMER_PROMOTION_REQUEST = "CONSUMER_PROMOTION_REQUEST";
  static CONSUMER_PROMOTION_SUCCESSFUL = "CONSUMER_PROMOTION_SUCCESSFUL";
  static CONSUMER_PROMOTION_FAILED = "CONSUMER_PROMOTION_FAILED";

  static consumerPromotionRequest() {
    return {
      type: this.CONSUMER_PROMOTION_REQUEST
    };
  }
  static consumerPromotionSuccessul(data) {
    return {
      type: this.CONSUMER_PROMOTION_SUCCESSFUL,
      data
    };
  }
  static consumerPromotionFailed(error) {
    return {
      type: this.CONSUMER_PROMOTION_FAILED,
      error
    };
  }

  //********** GET COMSUMER PROMOTION FROM ID ***********
  static GET_CONSUMER_PROMOTION_BY_ID_REQUEST = "GET_CONSUMER_PROMOTION_BY_ID_REQUEST";
  static GET_CONSUMER_PROMOTION_BY_ID_SUCCESSFUL = "GET_CONSUMER_PROMOTION_BY_ID_SUCCESSFUL";
  static GET_CONSUMER_PROMOTION_BY_ID_FAILED = "GET_CONSUMER_PROMOTION_BY_ID_FAILED";

  static getConsumerPromotionByIdRequest() {
    return {
      type: this.GET_CONSUMER_PROMOTION_BY_ID_REQUEST
    };
  }
  static getConsumerPromotionByIdSuccessul(data) {
    return {
      type: this.GET_CONSUMER_PROMOTION_BY_ID_SUCCESSFUL,
      data
    };
  }
  static getConsumerPromotionByIdFailed(error) {
    return {
      type: this.GET_CONSUMER_PROMOTION_BY_ID_FAILED,
      error
    };
  }

  //********** COMSUMER PROMOTION TYPES ***********
  static CONSUMER_PROMOTION_TYPES_REQUEST = "CONSUMER_PROMOTION_TYPES_REQUEST";
  static CONSUMER_PROMOTION_TYPES_SUCCESSFUL = "CONSUMER_PROMOTION_TYPES_SUCCESSFUL";
  static CONSUMER_PROMOTION_TYPES_FAILED = "CONSUMER_PROMOTION_TYPES_FAILED";

  static consumerPromotionTypesRequest() {
    return {
      type: this.CONSUMER_PROMOTION_TYPES_REQUEST
    };
  }
  static consumerPromotionTypesSuccessul(data) {
    return {
      type: this.CONSUMER_PROMOTION_TYPES_SUCCESSFUL,
      data
    };
  }
  static consumerPromotionTypesFailed(error) {
    return {
      type: this.CONSUMER_PROMOTION_TYPES_FAILED,
      error
    };
  }

  //********** UPDATE COMSUMER PROMOTION ***********
  static UPDATE_CONSUMER_PROMOTION_REQUEST = "UPDATE_CONSUMER_PROMOTION_REQUEST";
  static UPDATE_CONSUMER_PROMOTION_SUCCESSFUL = "UPDATE_CONSUMER_PROMOTION_SUCCESSFUL";
  static UPDATE_CONSUMER_PROMOTION_FAILED = "UPDATE_CONSUMER_PROMOTION_FAILED";

  static updateConsumerPromotionRequest() {
    return {
      type: this.UPDATE_CONSUMER_PROMOTION_REQUEST
    };
  }
  static updateConsumerPromotionSuccessul(data) {
    return {
      type: this.UPDATE_CONSUMER_PROMOTION_SUCCESSFUL,
      data
    };
  }
  static updateConsumerPromotionFailed(error) {
    return {
      type: this.UPDATE_CONSUMER_PROMOTION_FAILED,
      error
    };
  }

  //********** GET COMSUMER PROMOTION LIST ***********
  static GET_CONSUMER_PROMOTION_LIST_REQUEST = "GET_CONSUMER_PROMOTION_LIST_REQUEST";
  static GET_CONSUMER_PROMOTION_LIST_SUCCESSFUL = "GET_CONSUMER_PROMOTION_LIST_SUCCESSFUL";
  static GET_CONSUMER_PROMOTION_LIST_FAILED = "GET_CONSUMER_PROMOTION_LIST_FAILED";

  static getConsumerPromotionListRequest() {
    return {
      type: this.GET_CONSUMER_PROMOTION_LIST_REQUEST
    };
  }
  static getConsumerPromotionListSuccessul(data) {
    return {
      type: this.GET_CONSUMER_PROMOTION_LIST_SUCCESSFUL,
      data
    };
  }
  static getConsumerPromotionListFailed(error) {
    return {
      type: this.GET_CONSUMER_PROMOTION_LIST_FAILED,
      error
    };
  }

  //********** SUBMIT COMSUMER PROMOTION ***********
  static SUBMIT_CONSUMER_PROMOTION_REQUEST = "SUBMIT_CONSUMER_PROMOTION_REQUEST";
  static SUBMIT_CONSUMER_PROMOTION_SUCCESSFUL = "SUBMIT_CONSUMER_PROMOTION_SUCCESSFUL";
  static SUBMIT_CONSUMER_PROMOTION_FAILED = "SUBMIT_CONSUMER_PROMOTION_FAILED";

  static submitConsumerPromotionRequest() {
    return {
      type: this.SUBMIT_CONSUMER_PROMOTION_REQUEST
    };
  }
  static submitConsumerPromotionSuccessul(data) {
    return {
      type: this.SUBMIT_CONSUMER_PROMOTION_SUCCESSFUL,
      data
    };
  }
  static submitConsumerPromotionFailed(error) {
    return {
      type: this.SUBMIT_CONSUMER_PROMOTION_FAILED,
      error
    };
  }

  //********** COMSUMER PROMOTION HISTORY ***********
  static CONSUMER_PROMOTION_HISTORY_REQUEST = "CONSUMER_PROMOTION_HISTORY_REQUEST";
  static CONSUMER_PROMOTION_HISTORY_SUCCESSFUL = "CONSUMER_PROMOTION_HISTORY_SUCCESSFUL";
  static CONSUMER_PROMOTION_HISTORY_FAILED = "CONSUMER_PROMOTION_HISTORY_FAILED";

  static consumerPromotionHistoryRequest() {
    return {
      type: this.CONSUMER_PROMOTION_HISTORY_REQUEST
    };
  }
  static consumerPromotionHistorySuccessul(data) {
    return {
      type: this.CONSUMER_PROMOTION_HISTORY_SUCCESSFUL,
      data
    };
  }
  static consumerPromotionHistoryFailed(error) {
    return {
      type: this.CONSUMER_PROMOTION_HISTORY_FAILED,
      error
    };
  }

  //********** DEACTIVATE COMSUMER PROMOTION ***********
  static DEACTIVATE_CONSUMER_PROMOTION_REQUEST = "DEACTIVATE_CONSUMER_PROMOTION_REQUEST";
  static DEACTIVATE_CONSUMER_PROMOTION_SUCCESSFUL = "DEACTIVATE_CONSUMER_PROMOTION_SUCCESSFUL";
  static DEACTIVATE_CONSUMER_PROMOTION_FAILED = "DEACTIVATE_CONSUMER_PROMOTION_FAILED";

  static deactivateConsumerPromotionRequest() {
    return {
      type: this.DEACTIVATE_CONSUMER_PROMOTION_REQUEST
    };
  }
  static deactivateConsumerPromotionSuccessul(data) {
    return {
      type: this.DEACTIVATE_CONSUMER_PROMOTION_SUCCESSFUL,
      data
    };
  }
  static deactivateConsumerPromotionFailed(error) {
    return {
      type: this.DEACTIVATE_CONSUMER_PROMOTION_FAILED,
      error
    };
  }


  //**********  DELETE CP  **********

  static DELETE_CONSUMER_PROMOTION_REQUEST = 'DELETE_CONSUMER_PROMOTION_REQUEST';
  static DELETE_CONSUMER_PROMOTION_SUCCESS = 'DELETE_CONSUMER_PROMOTION_SUCCESS';
  static DELETE_CONSUMER_PROMOTION_FAILED = 'DELETE_CONSUMER_PROMOTION_FAILED';

  static deleteConsumerPromotionRequest() {
    return {
      type: this.DELETE_CONSUMER_PROMOTION_REQUEST
    };
  }

  static deleteConsumerPromotionSuccess(data) {
    return {
      type: this.DELETE_CONSUMER_PROMOTION_SUCCESS,
      data
    };
  }

  static deleteConsumerPromotionFailed(error) {
    return {
      type: this.DELETE_CONSUMER_PROMOTION_FAILED,
      error
    };
  }

  //********** GET COMSUMER PROMOTION LIST COUNT ***********
  static GET_CONSUMER_PROMOTION_LIST_COUNT_REQUEST = "GET_CONSUMER_PROMOTION_LIST_COUNT_REQUEST";
  static GET_CONSUMER_PROMOTION_LIST_COUNT_SUCCESSFUL = "GET_CONSUMER_PROMOTION_LIST_COUNT_SUCCESSFUL";
  static GET_CONSUMER_PROMOTION_LIST_COUNT_FAILED = "GET_CONSUMER_PROMOTION_LIST_COUNT_FAILED";

  static getConsumerPromotionListCountRequest() {
    return {
      type: this.GET_CONSUMER_PROMOTION_LIST_COUNT_REQUEST
    };
  }
  static getConsumerPromotionListCountSuccessul(data) {
    return {
      type: this.GET_CONSUMER_PROMOTION_LIST_COUNT_SUCCESSFUL,
      data
    };
  }
  static getConsumerPromotionListCountFailed(error) {
    return {
      type: this.GET_CONSUMER_PROMOTION_LIST_COUNT_FAILED,
      error
    };
  }
}

export default ConsumerPromotionActions;
